<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="fill"
      d="M6.85915 1.86667C6.73538 1.86667 6.61668 1.91584 6.52916 2.00335C6.44165 2.09087 6.39248 2.20957 6.39248 2.33334V3.26667H1.72581C1.47828 3.26667 1.24088 3.365 1.06585 3.54004C0.890814 3.71507 0.79248 3.95247 0.79248 4.2V9.8C0.79248 10.0475 0.890814 10.2849 1.06585 10.46C1.24088 10.635 1.47828 10.7333 1.72581 10.7333H6.39248V11.6667C6.39248 11.7904 6.44165 11.9091 6.52916 11.9967C6.61668 12.0842 6.73538 12.1333 6.85915 12.1333C6.98291 12.1333 7.10161 12.0842 7.18913 11.9967C7.27665 11.9091 7.32581 11.7904 7.32581 11.6667V2.33334C7.32581 2.20957 7.27665 2.09087 7.18913 2.00335C7.10161 1.91584 6.98291 1.86667 6.85915 1.86667ZM1.72581 9.8V4.2H6.39248V9.8H1.72581ZM14.7925 4.2V9.8C14.7925 10.0475 14.6941 10.2849 14.5191 10.46C14.3441 10.635 14.1067 10.7333 13.8591 10.7333H8.72581C8.60205 10.7333 8.48335 10.6842 8.39583 10.5967C8.30831 10.5091 8.25915 10.3904 8.25915 10.2667C8.25915 10.1429 8.30831 10.0242 8.39583 9.93669C8.48335 9.84917 8.60205 9.8 8.72581 9.8H13.8591V4.2H8.72581C8.60205 4.2 8.48335 4.15084 8.39583 4.06332C8.30831 3.9758 8.25915 3.8571 8.25915 3.73334C8.25915 3.60957 8.30831 3.49087 8.39583 3.40335C8.48335 3.31584 8.60205 3.26667 8.72581 3.26667H13.8591C14.1067 3.26667 14.3441 3.365 14.5191 3.54004C14.6941 3.71507 14.7925 3.95247 14.7925 4.2ZM5.45915 6.06667C5.45915 6.19044 5.40998 6.30913 5.32246 6.39665C5.23495 6.48417 5.11625 6.53334 4.99248 6.53334H4.52581V7.93334C4.52581 8.0571 4.47665 8.1758 4.38913 8.26332C4.30161 8.35084 4.18291 8.4 4.05915 8.4C3.93538 8.4 3.81668 8.35084 3.72916 8.26332C3.64165 8.1758 3.59248 8.0571 3.59248 7.93334V6.53334H3.12581C3.00205 6.53334 2.88335 6.48417 2.79583 6.39665C2.70831 6.30913 2.65915 6.19044 2.65915 6.06667C2.65915 5.9429 2.70831 5.8242 2.79583 5.73669C2.88335 5.64917 3.00205 5.6 3.12581 5.6H4.99248C5.11625 5.6 5.23495 5.64917 5.32246 5.73669C5.40998 5.8242 5.45915 5.9429 5.45915 6.06667Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "RenameIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
